//#region src/store/session/selectors.ts
var infoIsLoading = (state) => state.getIn ? state.getIn(["session", "infoIsLoading"]) : state.session.getIn(["infoIsLoading"]);
var infoIsLoaded = (state) => state.getIn ? state.getIn(["session", "infoIsLoaded"]) : state.session.getIn(["infoIsLoaded"]);
var human = (state) => state.getIn ? state.getIn([
	"session",
	"info",
	"human"
]) : state.session.getIn(["info", "human"]);
var loggedIn = (state) => state.getIn ? state.getIn([
	"session",
	"info",
	"logged_in"
], false) : state.session.getIn(["info", "logged_in"], false);
var loginRequestStatus = (state) => state.getIn ? state.getIn(["session", "loginRequestStatus"]).toJSON() : state.session.getIn(["loginRequestStatus"]).toJSON();
var registrationRequestStatus = (state) => state.getIn ? state.getIn(["session", "registrationRequestStatus"]).toJSON() : state.session.getIn(["registrationRequestStatus"]).toJSON();
var serverLoginRedirect = (state) => state.getIn ? state.getIn(["session", "serverLoginRedirect"]) : state.session.getIn(["serverLoginRedirect"]);
var email = (state) => state.getIn ? state.getIn(["session", "email"]) : state.session.getIn(["email"]);
var hasGeneratedPassword = (state) => state.getIn ? state.getIn(["session", "hasGeneratedPassword"]) : state.session.getIn(["hasGeneratedPassword"]);
var isNewHuman = (state) => state.getIn ? state.getIn(["session", "isNewHuman"]) : state.session.getIn(["isNewHuman"]);
var humanStatusRequestStatus = (state) => state.getIn ? state.getIn(["session", "humanStatusRequestStatus"]).toJSON() : state.session.getIn(["humanStatusRequestStatus"]).toJSON();
var resetPasswordRequestStatus = (state) => state.getIn ? state.getIn(["session", "resetPasswordRequestStatus"]).toJSON() : state.session.getIn(["resetPasswordRequestStatus"]).toJSON();
//#endregion
export { email, hasGeneratedPassword, human, humanStatusRequestStatus, infoIsLoaded, infoIsLoading, isNewHuman, loggedIn, loginRequestStatus, registrationRequestStatus, resetPasswordRequestStatus, serverLoginRedirect };

//# sourceMappingURL=selectors.mjs.map